import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Switch,
} from "@mui/material";
import { Field, Form, Formik } from "formik";
import { TextField as FormikTextField } from "formik-mui";

export default function GuideFormDialog({
  open,
  onClose,
  editingItem,
  validationSchema,
  onSubmit,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{editingItem ? "Edit Guide" : "Add Guide"}</DialogTitle>
      <Formik
        initialValues={{
          phone: editingItem?.phone || "",
          is_active: editingItem?.is_active ?? true,
          name: editingItem?.translations?.en?.name || editingItem?.name || "",
          agent_name:
            editingItem?.translations?.en?.agent_name || editingItem?.agent_name || "",
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ isSubmitting, values, setFieldValue }) => (
          <Form>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={Boolean(values.is_active)}
                        onChange={(e) => setFieldValue("is_active", e.target.checked)}
                      />
                    }
                    label="Active"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FormikTextField}
                    name="phone"
                    label="Phone"
                    fullWidth
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FormikTextField}
                    name="name"
                    label="Guide name"
                    fullWidth
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    component={FormikTextField}
                    name="agent_name"
                    label="Agent name"
                    fullWidth
                    variant="outlined"
                    size="small"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} disabled={isSubmitting}>
                Cancel
              </Button>
              <Button type="submit" variant="contained" disabled={isSubmitting}>
                {editingItem ? "Update" : "Create"}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}
